import { Reveal } from "@/lib/motion";
import { motion } from "framer-motion";

const steps = [
  { n: "01", title: "Request", body: "Set the address, time, and number of guards.", tag: "requested" },
  { n: "02", title: "Get Matched", body: "We dispatch vetted officers from a nearby partner agency.", tag: "en_route" },
  { n: "03", title: "Stay Protected", body: "Track arrival live, message your team, trigger SOS if needed.", tag: "active" },
];

const tagColor = {
  requested: "#D4AF37",
  en_route: "#F59E0B",
  active: "#3B82F6",
};

export const HowItWorks = () => {
  return (
    <section id="how" className="relative py-28 lg:py-36 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal><span className="kicker">How It Works</span></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-head font-black tracking-tight text-[#F8FAFC] text-4xl lg:text-6xl mt-6 max-w-3xl leading-[1.02]">
            Three steps to backup on-site.
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ duration: 0.25 }}
                data-testid={`step-${s.n}`}
                className="group relative h-full bg-[#0F172A] border border-[#1E293B] rounded-[20px] p-8 hover:border-[#D4AF37]/50 transition-colors duration-300"
              >
                <div className="font-head font-black text-6xl text-[#1E293B] group-hover:text-[#292414] transition-colors duration-300">
                  {s.n}
                </div>
                <h3 className="font-head font-bold text-[#F8FAFC] text-2xl mt-6">{s.title}</h3>
                <p className="font-body text-[#94A3B8] text-base leading-relaxed mt-3">{s.body}</p>
                <div
                  className="inline-flex items-center gap-2 mt-6 px-3 py-1.5 rounded-full text-xs font-semibold font-body border"
                  style={{ color: tagColor[s.tag], borderColor: tagColor[s.tag], background: `${tagColor[s.tag]}1f` }}
                >
                  <span className="w-1.5 h-1.5 rounded-full" style={{ background: tagColor[s.tag] }} />
                  {s.tag.replace("_", " ")}
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
